import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

/**
 * AboutSkeleton — for all /about/* pages
 * Pattern: Hero → image + text block → more text sections
 */
const AboutSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    <div className="container">
      {/* Main content: image + text */}
      <div className="sk-about-body">
        <SkeletonBox className="sk-about-img" />
        <div className="sk-about-text">
          <SkeletonBox className="sk-about-line-xl" />
          <SkeletonBox className="sk-about-line-lg" />
          <SkeletonBox className="sk-about-line-lg" />
          <SkeletonBox className="sk-about-line-lg" style={{ width: "90%" }} />
          <SkeletonBox className="sk-about-line-md" />
          <SkeletonBox className="sk-about-line-md" style={{ width: "85%" }} />
          <SkeletonBox className="sk-about-line-md" style={{ width: "60%" }} />
        </div>
      </div>

      {/* Second section — full-width text block */}
      <div style={{ padding: "20px 0 40px" }}>
        <SkeletonBox className="sk-section-title" style={{ marginLeft: 0 }} />
        <SkeletonBox className="sk-section-sub" style={{ marginLeft: 0, marginTop: 12 }} />
        <SkeletonBox className="sk-box" style={{ height: 16, marginTop: 20, borderRadius: 4 }} />
        <SkeletonBox className="sk-box" style={{ height: 16, marginTop: 10, borderRadius: 4, width: "90%" }} />
        <SkeletonBox className="sk-box" style={{ height: 16, marginTop: 10, borderRadius: 4, width: "80%" }} />
      </div>
    </div>
  </div>
);

export default AboutSkeleton;
